import { rem, Stack, Tabs, Title } from "@mantine/core";
import { useToggle } from "@mantine/hooks";
import { ProjectCards } from "components/project/ProjectCards";
import { PageContainer } from "components/_common/_page/PageContainer";
import { PageView } from "components/_common/_page/PageView";
import { BreadCrumbsPageBlock } from "components/_common/_page/_blocks/BreadCrumbsPageBlock";
import { useMobile } from "shared/hooks/useMobile";
import { useAllProjects } from "shared/hooks/_projects/useAllProducts";
import BootstrapGrid from "shared/ui/BootstrapGrid";

const breadCrumbsPageBlock = [{ title: "Главная", href: "/" }, { title: "Проекты" }];

export const ProjectsPage = () => {
  const { setMobileOption, setDesktopOption } = useMobile();
  const [value, toggle] = useToggle(["fundraising", "closed"]);
  const {
    data: projectsData,
    pending: projectsPending,
    error: projectsError,
  } = useAllProjects({
    customParams: {
      statuses: value,
    },
  });

  return (
    <PageView data={projectsData} pending={projectsPending} error={projectsError}>
      {(projectsData) => (
        <PageContainer component={"section"} id={"project-section"}>
          <BreadCrumbsPageBlock items={breadCrumbsPageBlock} />
          <BootstrapGrid.Row component={Stack}>
            <BootstrapGrid.Item without={"Pb"}>
              <Title order={2} fw={setMobileOption(500)} size={setMobileOption(rem(30))}>
                Проекты
              </Title>
            </BootstrapGrid.Item>
            <BootstrapGrid.Item without={"Pb"}>
              <Tabs defaultValue={"fundraising"} w={setDesktopOption("fit-content")}>
                <Tabs.List grow={setMobileOption(true)}>
                  <Tabs.Tab
                    p={"10px 20px"}
                    onClick={() => toggle("fundraising")}
                    value={"fundraising"}
                  >
                    Раунд открыт
                  </Tabs.Tab>
                  <Tabs.Tab p={"10px 20px"} onClick={() => toggle("closed")} value={"closed"}>
                    Раунд закрыт
                  </Tabs.Tab>
                </Tabs.List>
              </Tabs>
            </BootstrapGrid.Item>
            <BootstrapGrid.Item without={"Pb"}>
              <ProjectCards projects={projectsData.slice(0, 4)} />
            </BootstrapGrid.Item>
          </BootstrapGrid.Row>
        </PageContainer>
      )}
    </PageView>
  );
};
